// Extends From
import Startup from '@linc-technologies/linced-common/routes/startup';
// Ember Imports
import { service } from '@ember/service';

export default class ApplicationRoute extends Startup {
  @service
  applicationData;

  @service
  session;

  async model() {
    // Ensure application data is loaded before application route resolves.
    await this.applicationData.load();
    // This applicationData service is no longer necessary because we are
    // guaranteed to be completely set up by the time we hit this model and if
    // we select a school we reload the whole app anyway.
    // TODO: revert back to loading application data here.
    return this.applicationData;
  }
}
